import { render, staticRenderFns } from "./RatesInput.vue?vue&type=template&id=3d5caa5a&scoped=true&"
import script from "./RatesInput.vue?vue&type=script&lang=js&"
export * from "./RatesInput.vue?vue&type=script&lang=js&"
import style0 from "./RatesInput.vue?vue&type=style&index=0&id=3d5caa5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5caa5a",
  null
  
)

export default component.exports